import * as _ from 'lodash';
import * as moment from 'moment';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ILateRexmReportResponse, ReportActionCreators } from '@nkr/store/index';
import { ILateRexmCompliance } from '@nkr/models/index';
import { Button, FormControl, Label } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import Grid from './grid';

type MyColumn = ColDef | ColGroupDef;

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLateRexmReport: (month: number, year: number, centerId: number) => Promise<ILateRexmReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: ILateRexmCompliance[],
    centerId: number,
    currentMonth: string,
    columns: MyColumn[],
}

class RefrReport extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        centerId: 0,
        currentMonth: moment().format('MM/DD/YYYY'),
        columns: [],
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let currentMonth = moment(this.state.currentMonth)
        let month = currentMonth.get('month');
        let year = currentMonth.get('year');

        this.props.showLoading('Getting report, one moment please...').then(() => {
            this.props.getLateRexmReport(month + 1, year, this.props.centerId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        list: response.data.results
                    });
                }
            });
        });
    }

    getCenterList = () => {
        let list = this.state.list.map(x => {
            return { id: x.recipientCenterId, alias: x.recipientCenterAlias };
        });

        let centers = _.uniqBy(list, item => item.id);

        return _.sortBy(centers, item => item.alias);
    }

    getFilteredList = () => {
        return this.state.list.filter(x => {
            let centerFilter = this.state.centerId > 0 ? x.recipientCenterId == this.state.centerId : true;

            return centerFilter;
        });
    }

    handleMonthChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            currentMonth: e.currentTarget.value
        }, () => {
            this.getData();
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleExport = () => {
        let currentMonth = moment(this.state.currentMonth)
        let monthYear = currentMonth.format('MM-YYYY')

        let data = this.state.list;

        let csvContent = 'data:text/csv;charset=utf-8,'
            + 'Donor Center, Donor Exportable,Donor Alias,Recipient Center,Recipient Alias,Recipient Exportable,Date Requested,Expected Response By,Actual Response At, Response Details, Late, Pending, Days Late\n'
            + data.map(e => e.donorCenterAlias + ',' +
                e.donorIsExportable + ',' +   
                e.donorAlias + ',' +
                e.recipientCenterAlias + ',' +
                e.recipientAlias + ',' +
                e.recipientIsExportable + ',' +
                e.dateRequested + ',' +
                e.expectedResponseDate + ' 00:00,' +
                e.responseDateTime + ',' +
                e.responseDetails + ',' +
                e.isLate + ',' +
                e.isPending + ',' +
                e.daysLate
            ).join('\n');

        let encodedUri = encodeURI(csvContent);

        let link = document.createElement('a');

        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'refr-not-responded-to-within-2-business-days_' + monthYear + '.csv');

        document.body.appendChild(link);

        link.click();
    }

    render = () => {
        const centerList = this.getCenterList();
        const filteredList = this.getFilteredList();
        const dateRange = Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month');

        return (
            <div style={{ minHeight: 500, paddingLeft: this.props.isCenterLogin ? 20 : 0, paddingRight: this.props.isCenterLogin ? 20 : 0 }}>
                {this.props.isCenterLogin == false && (
                    <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>Requests for Donor Review not responded to within 2 business days</div>
                    </div>
                )}

                <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>Filter by Month:</div>
                            <div style={{ marginRight: 20 }}>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.currentMonth}
                                    onChange={this.handleMonthChange}>
                                    {dateRange.map(date =>
                                        <option key={`ctr-${date.format('MM/DD/YYYY')}`} value={date.format('MM/DD/YYYY')}>{date.format('MM/YYYY')}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>

                        {this.props.isCenterLogin == false && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Center:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {centerList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        )}
                    </div>

                    <div><Label>* Days Late does not include Saturday/Sunday</Label></div>

                    <div>
                        <Button onClick={this.handleExport}>Export to CSV</Button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-sm-12'>
                        <Grid data={filteredList} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLateRexmReport: (month, year, centerId) => {
            return dispatch(ReportActionCreators.getLateRexmsReport(month, year, centerId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(RefrReport);